export const PACKAGE_OMS_COMMAND_PENDING = "PACKAGE_OMS_COMMAND_PENDING";
export const PACKAGE_OMS_COMMAND_REJECTED = "PACKAGE_OMS_COMMAND_REJECTED";
export const PACKAGE_OMS_COMMAND_FULFILLED = "PACKAGE_OMS_COMMAND_FULFILLED";
export const CLEAR_PACKAGE_OMS_COMMAND = "CLEAR_PACKAGE_OMS_COMMAND";



// WEBPACK FOOTER //
// ./src/constants/packageOmsCommand.js